import { schema } from "normalizr";

const umweltplaketteSchema = new schema.Entity(
  "umweltplakette",
  {},
  { idAttribute: "id" }
);

export { umweltplaketteSchema };
